import {
  Applicant,
  ApplicationDocument,
  BankingApplicationDocument,
  Company,
  DO_APPLICATION_TYPE,
  LegalText,
  UserAccountInfo,
} from 'client-experience-toolbox';
import { DOTCheckResponse, BranchData } from './types';

export const SET_SECONDARY_NAV_START_INDEX = 'SET_SECONDARY_NAV_START_INDEX';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER_ACCOUNT_INFO = 'SET_USER_ACCOUNT_INFO';
export const SET_ACTIVE_FEATURES = 'SET_ACTIVE_FEATURES';
export const SET_COMPANY = 'SET_COMPANY';
export const SET_FACTORING_APPLICATION = 'SET_FACTORING_APPLICATION';
export const SET_FACTORING_SECTION = 'SET_FACTORING_SECTION';
export const SET_LEGAL_TEXTS = 'SET_LEGAL_TEXTS';
export const SET_VERIFIED_DOT = 'SET_VERIFIED_DOT';
export const ADD_ADDITIONAL_OWNER = 'ADD_ADDITIONAL_OWNER';
export const REMOVE_ADDITIONAL_OWNER = 'REMOVE_ADDITIONAL_OWNER';
export const SET_SUBMISSION_STATUS = 'SET_SUBMISSION_STATUS';
export const SET_DOT_CHECK_RESPONSE = 'SET_DOT_CHECK_RESPONSE';
export const SET_BRANCH_DATA = 'SET_BRANCH_DATA';
export const SET_BANKING_APPLICATION = 'SET_BANKING_APPLICATION';
export const SET_BANKING_SECTION = 'SET_BANKING_SECTION';
export const SET_POST_SUBMISSION_STEP = 'SET_POST_SUBMISSION_STEP';
export const SET_BANKING_SUBMISSION_ERROR = 'SET_BANKING_SUBMISSION_ERROR';
export const SET_PATCH_FULL_APPLICATION_ERROR = 'SET_PATCH_FULL_APPLICATION_ERROR';

interface SetUserTokenAction {
  type: typeof SET_TOKEN;
  token: string;
}

interface SetUserAccountInfoAction {
  type: typeof SET_USER_ACCOUNT_INFO;
  userAccountInfo: UserAccountInfo;
}

interface SetFeaturesAction {
  type: typeof SET_ACTIVE_FEATURES;
  activeFeatures: string[];
}

interface SetCompany {
  type: typeof SET_COMPANY;
  company: Company;
}

interface SetFactoringApplication {
  type: typeof SET_FACTORING_APPLICATION;
  factoringApplication: ApplicationDocument;
  sectionHasChanged: boolean;
}

interface SetverifiedDOTAction {
  type: typeof SET_VERIFIED_DOT;
  verifiedDOT: string;
}

interface SetLegalTexts {
  type: typeof SET_LEGAL_TEXTS;
  legalTexts: LegalText[];
  language: string;
}
interface SetFactoringSection {
  type: typeof SET_FACTORING_SECTION;
  factoringSection: number;
}

interface AddAdditionalOwnerAction {
  type: typeof ADD_ADDITIONAL_OWNER;
  ownerKey: string;
  applicationType: DO_APPLICATION_TYPE;
}

interface RemoveAdditionalOwnerAction {
  type: typeof REMOVE_ADDITIONAL_OWNER;
  owner: Partial<Applicant>;
  applicationType: DO_APPLICATION_TYPE;
}

interface SetSubmissionStatus {
  type: typeof SET_SUBMISSION_STATUS;
  submissionStatus: 'submitting' | 'submitted' | 'failed';
}

interface SetDOTCheckResponseAction {
  type: typeof SET_DOT_CHECK_RESPONSE;
  dotCheckResponse: DOTCheckResponse | undefined;
}

interface SetBranchDataAction {
  type: typeof SET_BRANCH_DATA;
  branchData: BranchData;
}

interface SetBankingApplication {
  type: typeof SET_BANKING_APPLICATION;
  bankingApplication: BankingApplicationDocument;
  sectionHasChanged: boolean;
}

interface SetBankingSection {
  type: typeof SET_BANKING_SECTION;
  bankingSection: number;
}

interface SetPostSubmissionStep {
  type: typeof SET_POST_SUBMISSION_STEP;
  submissionStep: number;
}

interface SetBankingSubmissionError {
  type: typeof SET_BANKING_SUBMISSION_ERROR;
  bankingSubmissionError: boolean;
}

interface SetPatchFullApplicationError {
  type: typeof SET_PATCH_FULL_APPLICATION_ERROR;
  patchFullApplicationError: boolean;
}

export type AppActionType =
  | SetUserAccountInfoAction
  | SetUserTokenAction
  | AddAdditionalOwnerAction
  | RemoveAdditionalOwnerAction
  | SetCompany
  | SetFeaturesAction
  | SetFactoringApplication
  | SetverifiedDOTAction
  | SetFactoringSection
  | SetLegalTexts
  | SetSubmissionStatus
  | SetDOTCheckResponseAction
  | SetBranchDataAction
  | SetBankingApplication
  | SetBankingSection
  | SetPostSubmissionStep
  | SetBankingSubmissionError
  | SetPatchFullApplicationError;
